var _defs, _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgIconLogout = function SvgIconLogout(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Logga ut"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Interface-Essential / Login/Logout / logout-1",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    "data-name": "Group 41"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape 129",
    d: "M8.814 12.131h12.929"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape 130",
    d: "M18.665 15.213l3.078-3.078-3.078-3.078"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape 131",
    d: "M15.586 15.826v3.694a1.179 1.179 0 01-1.12 1.231H4.392a1.18 1.18 0 01-1.119-1.231V4.743a1.179 1.179 0 011.119-1.231h10.075a1.179 1.179 0 011.12 1.231v3.694"
  }))))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconLogout, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/IconLogout.e0ae996a.svg";
export { ForwardRef as ReactComponent };